/* ==========================================================================
   roro-gift-pack-builder — el set de /pages/podarunky
   --------------------------------------------------------------------------
   Vanilla, sin build step, un componente por archivo (CLAUDE.md).

   QUÉ HACE Y QUÉ NO

   Hace: llevar el estado del set (añadir, quitar, cantidad), pintar el panel,
   mover la escalera y mandar todas las líneas al carrito de una sola llamada,
   marcadas con la propiedad `_roro_pack` para que el carrito las dibuje juntas.

   NO hace: aplicar rebajas. El descuento lo aplica Shopify al carrito pidiendo
   el CÓDIGO después de añadir, y a partir de ahí el precio lo calcula Shopify.
   Esta tienda cobra por `ro.ro pay`, al que los descuentos AUTOMÁTICOS no
   llegan (pedido #1568) y los CÓDIGOS sí: ver `rules/descuentos.md`.

   Sí ANTICIPA la cifra desde el 2026-09-03: pasado el umbral, el panel enseña
   el subtotal tachado y el precio ya rebajado con el porcentaje que llega en
   `data-gpb-disc-pct` — el ajuste de tienda, el mismo que escribe la escalera,
   nunca un número a mano. Sin código configurado Liquid no manda ni umbral ni
   porcentaje y el total vuelve a ser el subtotal a secas. Lo que sigue estando
   prohibido es prometer una rebaja que el checkout no vaya a cobrar: aquí la
   cobra, porque el código se pega al carrito y `applyPackDiscount` lo pide.

   REUTILIZA, NO DUPLICA
     · Los datos de producto son el mismo `[data-na-products]` que alimenta el
       bottom sheet (`snippets/roro-product-card-json.liquid`).
     · El selector de variante es ese mismo bottom sheet, en «modo set»:
       `assets/roro-product-carousel.js` emite `roro:pack:add` en vez de llamar
       a /cart/add.js cuando el root lleva `data-na-pack-mode`.
     · El patrón de estado, el formateo de moneda y el `notifyCart` vienen de
       `assets/roro-set-builder.js` (borrado el 2026-09-26), que ya los tenía resueltos.

   Rutas, formato de moneda y cadenas llegan por atributos `data-` y por los
   `<script type="application/json">` que renderiza Liquid: aquí no hay ninguna
   URL ni cadena visible dependiente del idioma.
   ========================================================================== */

(function () {
  'use strict';

  /* ---- Moneda -----------------------------------------------------------
     Réplica del filtro `money` de Liquid, igual que hacía
     `assets/roro-set-builder.js`. El formato NO se inventa: llega en
     `data-gpb-money-format` desde `shop.money_format`. */

  var ZERO_DECIMAL = ['JPY', 'KRW', 'VND', 'CLP', 'ISK', 'HUF', 'XOF', 'XAF', 'PYG', 'RWF', 'UGX', 'VUV'];

  function groupDigits(intPart, separator) {
    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  function formatMoney(cents, format, currency) {
    var precision = ZERO_DECIMAL.indexOf(String(currency).toUpperCase()) === -1 ? 2 : 0;
    var value = Number(cents) / Math.pow(10, precision);
    if (!isFinite(value)) value = 0;

    return String(format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      if (token === 'currency') return currency || '';

      var thousands = ',';
      var decimal = '.';
      var digits = precision;

      switch (token) {
        case 'amount':
          break;
        case 'amount_no_decimals':
          digits = 0;
          break;
        case 'amount_with_comma_separator':
          thousands = '.';
          decimal = ',';
          break;
        case 'amount_no_decimals_with_comma_separator':
          thousands = '.';
          digits = 0;
          break;
        case 'amount_no_decimals_with_space_separator':
          thousands = ' ';
          digits = 0;
          break;
        case 'amount_with_space_separator':
          thousands = ' ';
          decimal = ',';
          break;
        case 'amount_with_period_and_space_separator':
          thousands = ' ';
          decimal = '.';
          break;
        case 'amount_with_apostrophe_separator':
          thousands = "'";
          decimal = '.';
          break;
        default:
          return '';
      }

      var fixed = value.toFixed(digits);
      var parts = fixed.split('.');
      var out = groupDigits(parts[0], thousands);
      return digits > 0 ? out + decimal + parts[1] : out;
    });
  }

  /* ---- Utilidades ------------------------------------------------------- */

  function readJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * Plural ucraniano: 1 / 2-4 / 5+. Las tres formas llegan traducidas desde
   * Liquid (`roro.gift_pack.item_count` pedido con count 1, 3 y 5) pero con el
   * número todavía sin rellenar: la clave usa `{{ n }}` para el hueco visible y
   * reserva `count` para elegir la forma, así que aquí solo hay que decidir cuál
   * de las tres y escribir el número de verdad.
   */
  function pluralUk(count, strings) {
    return pluralForm(count, strings.itemCountOne, strings.itemCountFew, strings.itemCountMany);
  }

  /** La forma ucraniana (1 / 2-4 / 5+) con el número ya dentro de `__N__`. */
  function pluralForm(count, one, few, many) {
    var mod100 = count % 100;
    var mod10 = count % 10;
    var form;

    if (mod100 >= 11 && mod100 <= 14) {
      form = many;
    } else if (mod10 === 1) {
      form = one;
    } else if (mod10 >= 2 && mod10 <= 4) {
      form = few;
    } else {
      form = many;
    }

    return String(form || '').replace(/__N__/g, String(count));
  }

  function newToken() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  /* ---- Instancia -------------------------------------------------------- */

  function initRoot(root) {
    if (!root || root.dataset.gpbInit === 'true') return;
    root.dataset.gpbInit = 'true';

    var SECTION_ID = root.dataset.sectionId || '';
    var ROUTES = {
      add: root.dataset.naAddUrl || '/cart/add.js',
      cart: root.dataset.naCartUrl || '/cart.js'
    };
    var MONEY_FORMAT = root.dataset.gpbMoneyFormat || '{{amount}}';
    var CURRENCY = root.dataset.gpbCurrency || '';
    var MAX_QTY = parseInt(root.dataset.gpbMaxQty, 10) || 5;
    // `compact`: la cantidad vive en la tarjeta («− N +») y el panel no se
    // abre en cada añadido. Ver el ajuste `card_add_style` de la sección.
    var COMPACT = root.dataset.gpbCardStyle === 'compact';

    var SHIP_THRESHOLD = parseInt(root.dataset.gpbShipThreshold, 10) || 0;
    // Vacío = el peldaño del descuento no existe. Liquid ya no lo pinta; aquí
    // tampoco se pide ningún código.
    var PACK_CODE = (root.dataset.gpbCode || '').trim();
    var DISC_THRESHOLD = parseInt(root.dataset.gpbDiscThreshold, 10) || 0;
    // Porcentaje del código: solo para enseñar el precio rebajado junto al
    // subtotal. Ausente = 0 y `discountedTotal` devuelve null (una sola cifra).
    var DISC_PCT = parseFloat(root.dataset.gpbDiscPct) || 0;
    // Piezas que pide el código además del subtotal (2026-10-08): un set de una
    // sola pieza va a precio normal aunque pase de ₴3.000.
    var DISC_MIN_ITEMS = parseInt(root.dataset.gpbDiscMinItems, 10);
    if (!(DISC_MIN_ITEMS >= 1)) DISC_MIN_ITEMS = 2;

    var PRODUCTS = readJSON(root.querySelector('[data-na-products]')) || [];
    var STRINGS = readJSON(root.querySelector('[data-gpb-strings]')) || {};

    var BY_ID = {};
    var VARIANT_OWNER = {};
    PRODUCTS.forEach(function (p) {
      BY_ID[String(p.id)] = p;
      (p.variants || []).forEach(function (v) {
        VARIANT_OWNER[String(v.id)] = p;
      });
    });

    var refs = {
      aside: root.querySelector('[data-gpb-aside]'),
      scrim: root.querySelector('[data-gpb-scrim]'),
      toggle: root.querySelector('[data-gpb-toggle]'),
      body: root.querySelector('[data-gpb-body]'),
      barCount: root.querySelector('[data-gpb-bar-count]'),
      barTotal: root.querySelector('[data-gpb-bar-total]'),
      ladderText: root.querySelector('[data-gpb-ladder-text]'),
      steps: Array.prototype.slice.call(root.querySelectorAll('[data-gpb-step]')),
      count: root.querySelector('[data-gpb-count]'),
      lines: root.querySelector('[data-gpb-lines]'),
      placeholder: root.querySelector('[data-gpb-placeholder]'),
      total: root.querySelector('[data-gpb-total]'),
      totalRow: root.querySelector('[data-gpb-total-row]'),
      totalWas: root.querySelector('[data-gpb-total-was]'),
      totalWasValue: root.querySelector('[data-gpb-total-was-value]'),
      totalAfter: root.querySelector('[data-gpb-total-after]'),
      cta: root.querySelector('[data-gpb-add]'),
      feedback: root.querySelector('[data-gpb-feedback]')
    };

    /* ---- Estado --------------------------------------------------------
       Una entrada por VARIANTE, no por producto: dos colores de la misma
       chashka son dos líneas distintas, igual que en el carrito. */
    var lines = [];
    var STORAGE_KEY = 'roro:gift-pack:' + SECTION_ID;

    function money(cents) {
      return formatMoney(cents, MONEY_FORMAT, CURRENCY);
    }

    /* Como `money_without_trailing_zeros`: sin «.00» si el importe es redondo,
       con los céntimos si los hay. Solo para la frase de la escalera, igual que
       en el side cart (2026-10-27): «Ще ₴800 і знижка 5%» cabe en una línea. */
    function moneyShort(cents) {
      var out = money(cents);
      return Number(cents) % 100 === 0 ? out.replace(/[.,]00(?!\d)/, '') : out;
    }

    function variantOf(variantId) {
      var product = VARIANT_OWNER[String(variantId)];
      if (!product) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(variantId)) {
          return product.variants[i];
        }
      }
      return null;
    }

    function subtotal() {
      return lines.reduce(function (sum, line) {
        var variant = variantOf(line.variantId);
        return variant ? sum + variant.priceCents * line.qty : sum;
      }, 0);
    }

    function itemCount() {
      return lines.reduce(function (sum, line) {
        return sum + line.qty;
      }, 0);
    }

    /**
     * ¿Llega el set al código? Importe Y piezas, la misma regla con la que
     * `assets/roro-cart-bundle-discount.js` pega y suelta el código del carrito
     * (`packQualifies`). Sin código o sin umbral, nunca.
     */
    function qualifies(total, units) {
      return DISC_THRESHOLD > 0 && DISC_PCT > 0 && total >= DISC_THRESHOLD && units >= DISC_MIN_ITEMS;
    }

    /** Una línea con el −X% restado, redondeada a la subunidad como Shopify. */
    function discounted(cents) {
      return cents - Math.round((cents * DISC_PCT) / 100);
    }

    /**
     * Lo que va a cobrar el carrito una vez aplicado el código, o `null` si el
     * set todavía no llega al umbral. Es la SUMA de las líneas rebajadas y no
     * el −X% del total: así cuadra con lo que dice cada línea, y Shopify también
     * reparte la rebaja línea a línea (2026-10-01). Gemelo de `renderTotal()`
     * en `assets/roro-pair-picker.js`: si se toca uno, mirar el otro.
     */
    function discountedTotal(total) {
      if (!qualifies(total, itemCount())) return null;
      return lines.reduce(function (sum, line) {
        var variant = variantOf(line.variantId);
        return variant ? sum + discounted(variant.priceCents * line.qty) : sum;
      }, 0);
    }

    /* ---- Persistencia ---------------------------------------------------
       sessionStorage y no localStorage: un set a medio montar es una intención
       de esta visita, no una lista de deseos. Al releer se valida cada id
       contra el JSON que Liquid acaba de renderizar, así que una variante que
       ya no existe (o que salió de la colección) simplemente se cae. */
    function save() {
      try {
        window.sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(
            lines.map(function (line) {
              return [line.variantId, line.qty];
            })
          )
        );
      } catch (e) {
        /* Modo privado o cuota llena: el set sigue funcionando en memoria. */
      }
    }

    function restore() {
      var raw;
      try {
        raw = window.sessionStorage.getItem(STORAGE_KEY);
      } catch (e) {
        return;
      }
      if (!raw) return;

      var stored;
      try {
        stored = JSON.parse(raw);
      } catch (e) {
        return;
      }
      if (!Array.isArray(stored)) return;

      stored.forEach(function (pair) {
        if (!Array.isArray(pair)) return;
        var variant = variantOf(pair[0]);
        if (!variant || !variant.available) return;
        var qty = parseInt(pair[1], 10);
        if (!isFinite(qty) || qty < 1) return;
        lines.push({ variantId: String(pair[0]), qty: Math.min(qty, MAX_QTY) });
      });
    }

    /* ---- Mutaciones ----------------------------------------------------- */

    function findLine(variantId) {
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].variantId === String(variantId)) return lines[i];
      }
      return null;
    }

    function addVariant(variantId) {
      var variant = variantOf(variantId);
      if (!variant || !variant.available) return;

      var line = findLine(variantId);
      if (line) {
        if (line.qty >= MAX_QTY) return;
        line.qty += 1;
      } else {
        lines.push({ variantId: String(variantId), qty: 1 });
      }

      hideFeedback();
      commit();
      // En los dos modos, también en `compact`: se probó a no abrirlo y Max lo
      // quiso de vuelta (2026-09-29). El panel enseña adónde ha ido la pieza.
      openPanel();
    }

    /** La última línea del set que es de este producto (la que quita el «−»). */
    function lastLineOf(productId) {
      for (var i = lines.length - 1; i >= 0; i--) {
        var owner = VARIANT_OWNER[lines[i].variantId];
        if (owner && String(owner.id) === String(productId)) return lines[i];
      }
      return null;
    }

    function setQty(variantId, qty) {
      var line = findLine(variantId);
      if (!line) return;

      if (qty < 1) {
        lines = lines.filter(function (l) {
          return l !== line;
        });
      } else {
        line.qty = Math.min(qty, MAX_QTY);
      }

      commit();
    }

    function commit() {
      save();
      render();
    }

    /* ---- Pintado -------------------------------------------------------- */

    function renderLines(total) {
      if (!refs.lines) return;
      refs.lines.textContent = '';
      var setOn = qualifies(total, itemCount());

      lines.forEach(function (line) {
        var variant = variantOf(line.variantId);
        var product = VARIANT_OWNER[String(line.variantId)];
        if (!variant || !product) return;

        var li = document.createElement('li');
        li.className = 'rgp__line';

        // Foto y nombre llevan a la ficha (2026-09-27, dead clicks en Clarity). El set no se pierde
        // al volver: vive en sessionStorage. La foto va fuera del tabulador y oculta a lectores
        // porque el nombre ya es el mismo enlace.
        var media = document.createElement('a');
        media.className = 'rgp__line-media';
        media.href = product.url;
        media.tabIndex = -1;
        media.setAttribute('aria-hidden', 'true');

        var img = document.createElement('img');
        img.className = 'rgp__line-thumb';
        img.src = variant.image || product.image || '';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 56;
        img.height = 56;
        media.appendChild(img);
        li.appendChild(media);

        var text = document.createElement('div');
        text.className = 'rgp__line-text';

        var name = document.createElement('a');
        name.className = 'rgp__line-name';
        name.href = product.url;
        name.textContent = product.title;
        text.appendChild(name);

        if (product.variants.length > 1) {
          var opt = document.createElement('span');
          opt.className = 'rgp__line-opt';
          opt.textContent = variant.title;
          text.appendChild(opt);
        }

        var qtyBox = document.createElement('div');
        qtyBox.className = 'rgp__line-qty';

        var minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'rgp__qty-btn';
        minus.textContent = '−';
        minus.setAttribute('aria-label', STRINGS.decrease || '');
        minus.addEventListener('click', function () {
          setQty(line.variantId, line.qty - 1);
        });
        qtyBox.appendChild(minus);

        var value = document.createElement('span');
        value.className = 'rgp__qty-value';
        value.textContent = String(line.qty);
        qtyBox.appendChild(value);

        var plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'rgp__qty-btn';
        plus.textContent = '+';
        plus.disabled = line.qty >= MAX_QTY;
        plus.setAttribute('aria-label', STRINGS.increase || '');
        plus.addEventListener('click', function () {
          setQty(line.variantId, line.qty + 1);
        });
        qtyBox.appendChild(plus);

        text.appendChild(qtyBox);
        li.appendChild(text);

        var side = document.createElement('div');
        side.className = 'rgp__line-side';

        // Pasado el umbral, cada línea dice lo que se paga en este set: el
        // precio de la ficha tachado y el rebajado en rojo. El total es su suma.
        var price = document.createElement('span');
        price.className = 'rgp__line-price';
        var lineCents = variant.priceCents * line.qty;
        if (setOn) {
          var was = document.createElement('s');
          was.className = 'rgp__line-was';
          was.textContent = money(lineCents);
          var now = document.createElement('span');
          now.className = 'rgp__line-now';
          now.textContent = money(discounted(lineCents));
          price.appendChild(was);
          price.appendChild(now);
        } else {
          price.textContent = money(lineCents);
        }
        side.appendChild(price);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'rgp__line-remove';
        remove.setAttribute('aria-label', (STRINGS.remove || '') + ' — ' + product.title);
        remove.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
          '<path d="M5 7h14M10 7V5h4v2M7 7l1 13h8l1-13" stroke="currentColor" stroke-width="1.6" ' +
          'stroke-linecap="round" stroke-linejoin="round"/></svg>';
        remove.addEventListener('click', function () {
          setQty(line.variantId, 0);
        });
        side.appendChild(remove);

        li.appendChild(side);
        refs.lines.appendChild(li);
      });
    }

    /**
     * La escalera. Cada peldaño se llena entre su propio `from` y su `to`, así
     * que no hay ninguna posición absoluta que calcular y en un móvil de 375px
     * las dos etiquetas caben sin pisarse.
     */
    /**
     * Dos medidas, las mismas que la escalera del side cart: el peldaño del
     * descuento mira el SUBTOTAL (es lo que mira el mínimo del código) y el del
     * envío gratis mira lo que se PAGA, que es lo que mira ro.ro pay. Comprobado
     * en Chekly el 2026-10-01: collar de ₴4.300 → «Лише 915 грн» (₴5.000 − ₴4.085).
     * Antes los dos miraban el subtotal, y un set de ₴5.100 (₴4.845 a pagar)
     * prometía envío gratis que el checkout no daba.
     *
     * @param {number} total - Subtotal del set, sin rebajar.
     * @param {number|null} payable - Lo que se paga, o null si no hay rebaja.
     */
    function renderLadder(total, payable) {
      var paid = payable === null ? total : payable;
      // El peldaño del descuento pide además piezas (2026-10-08). Con el importe
      // y sin las piezas, ni se marca hecho ni se llena: se queda en el 90%,
      // «casi», y la frase pide la pieza que falta. Igual que la escalera del
      // side cart (`snippets/roro-cart-shipping-bar.liquid`).
      var units = itemCount();
      var unitsLeft = Math.max(0, DISC_MIN_ITEMS - units);

      refs.steps.forEach(function (step) {
        var isDiscount = step.dataset.gpbStep !== 'shipping';
        var measure = isDiscount ? total : paid;
        var from = parseInt(step.dataset.gpbStepFrom, 10) || 0;
        var to = parseInt(step.dataset.gpbStepTo, 10) || 0;
        var fill = step.querySelector('[data-gpb-step-fill]');
        var span = to - from;
        var pct = 0;
        var done = measure >= to && to > 0 && (!isDiscount || unitsLeft === 0);

        if (span > 0) {
          pct = Math.max(0, Math.min(100, ((measure - from) / span) * 100));
        } else if (measure >= to) {
          pct = 100;
        }
        if (isDiscount && !done && pct > 90) pct = 90;

        if (fill) fill.style.setProperty('--gpb-step-progress', pct + '%');
        step.classList.toggle('is-done', done);
      });

      if (!refs.ladderText) return;

      // La frase sigue al peldaño más bajo que TODAVÍA no se ha cumplido, y
      // cuando ya no queda ninguno, al más alto que sí. Ordenar por umbral y no
      // por tipo es lo que permite que el descuento vaya por debajo del envío
      // gratis (₴3.000 / ₴5.000) sin cablear nada: quién va primero lo deciden
      // los ajustes, igual que en el Liquid.
      var rungs = [];

      if (SHIP_THRESHOLD > 0) {
        rungs.push({ to: SHIP_THRESHOLD, at: paid, left: STRINGS.shippingLeftHtml, done: STRINGS.shippingDone });
      }
      if (DISC_THRESHOLD > 0) {
        rungs.push({
          to: DISC_THRESHOLD,
          at: total,
          left: STRINGS.discountLeftHtml,
          done: STRINGS.discountDone,
          // Importe cumplido pero faltan piezas: la frase pide la pieza.
          piece:
            unitsLeft > 0
              ? pluralForm(unitsLeft, STRINGS.discountPieceOne, STRINGS.discountPieceFew, STRINGS.discountPieceMany)
              : ''
        });
      }
      rungs.sort(function (a, b) {
        return a.to - b.to;
      });

      var html = '';
      var next = null;

      for (var i = 0; i < rungs.length; i++) {
        if (rungs[i].at < rungs[i].to || rungs[i].piece) {
          next = rungs[i];
          break;
        }
      }

      if (next && next.at >= next.to) {
        html = String(next.piece);
      } else if (next) {
        html = String(next.left || '').replace('__AMOUNT__', moneyShort(next.to - next.at));
      } else if (rungs.length) {
        html = String(rungs[rungs.length - 1].done || '');
      }

      // El HTML sale de `locales/uk.json` (lleva un <b>) y del formateador de
      // moneda de este archivo. Nada de esto es entrada de usuario.
      refs.ladderText.innerHTML = html;
    }

    /** El «×N» sobre la tarjeta de una pieza que ya está en el set. */
    function renderBadges() {
      var perProduct = {};
      lines.forEach(function (line) {
        var product = VARIANT_OWNER[String(line.variantId)];
        if (!product) return;
        var key = String(product.id);
        perProduct[key] = (perProduct[key] || 0) + line.qty;
      });

      root.querySelectorAll('[data-gpb-cell]').forEach(function (cell) {
        var badge = cell.querySelector('[data-gpb-cell-badge]');
        var productBadge = cell.querySelector('.na-card__badge');
        var qty = perProduct[cell.dataset.gpbCell] || 0;
        if (badge) {
          if (qty > 0) {
            badge.hidden = false;
            badge.textContent = qty > 1 ? '×' + qty : STRINGS.inPack || '✓';
          } else {
            badge.hidden = true;
            badge.textContent = '';
          }
        }
        if (qty > 0) {
          cell.classList.add('is-in-pack');
          cell.setAttribute('data-in-pack', 'true');
          if (productBadge) productBadge.style.display = 'none';
        } else {
          cell.classList.remove('is-in-pack');
          cell.removeAttribute('data-in-pack');
          if (productBadge) productBadge.style.display = '';
        }
        if (COMPACT) renderCardQty(cell, qty);
      });
    }

    /**
     * «− N» a la izquierda del botón «+» de la tarjeta (modo `compact`).
     * El «+» del contador NO es un botón nuevo: es el mismo `.na-card__atc` de
     * siempre, que ya sabe meter de un toque una pieza de variante única y
     * abrir el bottom sheet cuando hay que elegir. Así el sheet devuelve el foco
     * a un botón que sigue visible, y no hay dos caminos para añadir.
     */
    function renderCardQty(cell, qty) {
      var atc = cell.querySelector('.na-card__atc');
      if (!atc) return;

      var box = cell.querySelector('[data-gpb-card-qty]');
      if (!box) {
        var product = BY_ID[cell.dataset.gpbCell];
        box = document.createElement('div');
        box.className = 'rgp__card-qty';
        box.setAttribute('data-gpb-card-qty', '');

        var minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'rgp__card-qty-btn';
        minus.setAttribute('data-gpb-card-minus', '');
        minus.setAttribute('aria-label', (STRINGS.decrease || '') + (product ? ': ' + product.title : ''));
        minus.textContent = '−';
        box.appendChild(minus);

        var value = document.createElement('span');
        value.className = 'rgp__card-qty-value';
        value.setAttribute('aria-live', 'polite');
        value.innerHTML = '<span class="visually-hidden"></span><span data-gpb-card-qty-n></span>';
        value.firstChild.textContent = (STRINGS.inPack || '') + ': ';
        box.appendChild(value);

        atc.parentNode.insertBefore(box, atc);
      }

      var hadFocus = box.contains(document.activeElement) ? document.activeElement : null;
      box.querySelector('[data-gpb-card-qty-n]').textContent = qty > 0 ? String(qty) : '';

      // Con una sola variante, el «+» no puede pasar del máximo por línea.
      var single = BY_ID[cell.dataset.gpbCell];
      var maxed = qty >= MAX_QTY && single && single.variants && single.variants.length === 1;
      cell.classList.toggle('is-pack-max', !!maxed);
      if (maxed) {
        atc.setAttribute('aria-disabled', 'true');
      } else {
        atc.removeAttribute('aria-disabled');
      }

      // El «−» que llevó la cantidad a 0 desaparece con ella: el foco pasa al
      // botón «+», que es lo que queda en su sitio.
      if (qty === 0 && hadFocus) atc.focus({ preventScroll: true });
    }

    if (COMPACT) {
      root.addEventListener('click', function (event) {
        var minus = event.target.closest && event.target.closest('[data-gpb-card-minus]');
        if (!minus) return;
        var cell = minus.closest('[data-gpb-cell]');
        var line = cell && lastLineOf(cell.dataset.gpbCell);
        if (line) setQty(line.variantId, line.qty - 1);
      });
    }

    function render() {
      var total = subtotal();
      var count = itemCount();
      var label = count > 0 ? pluralUk(count, STRINGS) : '';

      // Lo que se paga, si el set llega al umbral: lo usan la escalera (envío
      // gratis), la barra móvil y el total.
      var payable = discountedTotal(total);

      renderLines(total);
      renderLadder(total, payable);
      renderBadges();

      if (refs.count) refs.count.textContent = label;
      if (refs.barCount) refs.barCount.textContent = label;
      // La barra móvil enseña una sola cifra, y es la que se va a pagar: es un
      // resumen de una línea, no el sitio para dos precios.
      var shown = payable === null ? total : payable;

      if (refs.barTotal) refs.barTotal.textContent = count > 0 ? money(shown) : '';
      if (refs.total) refs.total.textContent = money(shown);
      if (refs.totalRow) refs.totalRow.classList.toggle('is-discounted', payable !== null);
      if (refs.totalWas) {
        refs.totalWas.hidden = payable === null;
        if (refs.totalWasValue) refs.totalWasValue.textContent = payable === null ? '' : money(total);
      }
      if (refs.totalAfter) refs.totalAfter.hidden = payable === null;
      if (refs.placeholder) refs.placeholder.hidden = count > 0;
      if (refs.cta) refs.cta.disabled = count === 0;
    }

    /* ---- Panel: abrir y cerrar (solo móvil; en escritorio el CSS manda) --- */

    var isOpen = false;

    function syncPanel() {
      if (!refs.aside || !refs.body || !refs.toggle) return;
      refs.aside.classList.toggle('is-open', isOpen);
      refs.body.hidden = !isOpen;
      refs.toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      refs.toggle.setAttribute('aria-label', (isOpen ? STRINGS.closePanel : STRINGS.openPanel) || '');
    }

    function openPanel() {
      if (isOpen) return;
      isOpen = true;
      syncPanel();
    }

    function closePanel() {
      if (!isOpen) return;
      isOpen = false;
      syncPanel();
    }

    if (refs.toggle) {
      refs.toggle.addEventListener('click', function () {
        isOpen = !isOpen;
        syncPanel();
      });
    }

    if (refs.scrim) refs.scrim.addEventListener('click', closePanel);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel();
    });

    /* ---- Entradas: el bottom sheet y el «+» de una pieza sin variantes --- */

    root.addEventListener('roro:pack:add', function (event) {
      var variantId = event.detail && event.detail.variantId;
      if (variantId) addVariant(variantId);
    });

    /* ---- Carrito -------------------------------------------------------- */

    function showFeedback(message, isError) {
      if (!refs.feedback) return;
      refs.feedback.hidden = false;
      refs.feedback.textContent = message;
      refs.feedback.classList.toggle('rgp__feedback--error', !!isError);
    }

    function hideFeedback() {
      if (!refs.feedback) return;
      refs.feedback.hidden = true;
      refs.feedback.textContent = '';
      refs.feedback.classList.remove('rgp__feedback--error');
    }

    /**
     * `<cart-icon>` escucha `cart:update` y lee `detail.data.itemCount`. Se
     * emite el recuento ABSOLUTO releído de /cart.js, y sin
     * `source: 'product-form-component'`: con ese source el icono suma en vez
     * de asignar y el número queda doblado (rules/liquid-patterns.md).
     */
    function notifyCart(cart, sections) {
      var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart || undefined,
            sourceId: 'roro-gift-pack-builder-' + SECTION_ID,
            data: {
              source: 'roro-gift-pack-builder',
              itemCount: count,
              didError: false,
              sections: sections
            }
          }
        })
      );

      var fallbacks = '[data-cart-count], .cart-count, #cart-icon-bubble, .cart-bubble__text-count';
      document.querySelectorAll(fallbacks).forEach(function (el) {
        // Solo nodos hoja: nunca sobrescribir marcado ajeno.
        if (el.children.length === 0) el.textContent = count < 100 ? String(count) : '99+';
        if (count > 0) el.classList.remove('hidden');
      });
    }

    /**
     * `RoroCart.get` nunca lanza: devuelve el carrito o `null`. Aquí un `null`
     * se traduce a un objeto vacío para que `applyPackCode` y `notifyCart`
     * sigan su camino sin comprobar nada — lo peor que pasa es que el contador
     * no se actualice, no que se rompa el añadido.
     */
    function getCart() {
      return window.RoroCart.get(ROUTES.cart).then(function (cart) {
        return cart || {};
      });
    }

    function hasCode(cart, code) {
      var codes = (cart && cart.discount_codes) || [];
      var wanted = String(code).toUpperCase();
      for (var i = 0; i < codes.length; i++) {
        if (String(codes[i].code || '').toUpperCase() === wanted) return true;
      }
      return false;
    }

    /**
     * Pide el código al carrito. Mismo mecanismo que
     * `assets/roro-cart-bundle-discount.js`, y por la misma razón: un
     * automático nunca llega a `ro.ro pay`, un código sí, porque va pegado al
     * carrito y el carrito es lo que Chekly lee por el `cartToken`.
     *
     * Se pide solo si el CARRITO entero es un set con derecho: piezas y
     * subtotal antes de rebajas, sin tarjetas regalo. Es `packQualifies()` de
     * `assets/roro-cart-bundle-discount.js`, que además lo suelta si el carrito
     * deja de cumplir: si se toca una, la otra. Hasta el 2026-10-08 aquí se
     * miraba `total_price` a secas, y un collar solo de ₴4.300 pedía el código.
     */
    function cartQualifies(cart) {
      if (!cart || !Array.isArray(cart.items)) return false;
      var subtotal = typeof cart.original_total_price === 'number' ? cart.original_total_price : cart.total_price;
      var units = 0;
      cart.items.forEach(function (item) {
        if (item.gift_card) {
          subtotal -= item.original_line_price || 0;
        } else {
          units += item.quantity || 0;
        }
      });
      return units >= DISC_MIN_ITEMS && subtotal >= DISC_THRESHOLD;
    }

    function applyPackCode(cart) {
      if (!PACK_CODE || DISC_THRESHOLD <= 0) return Promise.resolve(cart);
      // `shopify theme dev` responde 401 a `/discount/`: en local no se pide
      // (mismo motivo que en `roro-cart-bundle-discount.js`).
      if (/^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname)) return Promise.resolve(cart);
      if (!cartQualifies(cart)) return Promise.resolve(cart);
      if (hasCode(cart, PACK_CODE)) return Promise.resolve(cart);

      // `?redirect=/cart.js` no es un adorno: sin él Shopify responde con un
      // 302 a la home y el fetch se descarga la página entera.
      return fetch('/discount/' + encodeURIComponent(PACK_CODE) + '?redirect=/cart.js', {
        credentials: 'same-origin'
      })
        .then(getCart)
        .catch(function () {
          return cart;
        });
    }

    /**
     * Las mismas secciones que trajo el `add`, pintadas otra vez con el
     * carrito de ahora (Section Rendering API). Nunca rechaza: si algo falla
     * devuelve `undefined`, y sin `sections` `cart-items-component` repinta el
     * cajón por su cuenta.
     *
     * @param {Object} [sections] - `result.data.sections` del `add`.
     * @returns {Promise<Object|undefined>}
     */
    function freshSections(sections) {
      var ids = sections && typeof sections === 'object' ? Object.keys(sections) : [];
      if (!ids.length) return Promise.resolve(undefined);

      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), {
        credentials: 'same-origin'
      })
        .then(function (response) {
          return response.ok ? window.RoroCart.json(response) : {};
        })
        .then(function (data) {
          return ids.every(function (id) { return typeof data[id] === 'string'; }) ? data : undefined;
        })
        .catch(function () {
          return undefined;
        });
    }

    if (refs.cta) {
      refs.cta.addEventListener('click', function () {
        if (!lines.length) return;

        // Token compartido por todas las líneas de este set. Es lo que lee
        // `snippets/cart-products.liquid` para dibujarlas como un bloque, y lo
        // que deja rastro en el Admin: el embudo nativo de Shopify está ciego
        // en esta tienda (docs/negocio.md), así que marcar las líneas es la
        // única forma de saber si el set mueve el AOV. El prefijo `_` la
        // esconde del cliente en carrito y checkout.
        var token = newToken();

        var items = lines.map(function (line) {
          return {
            id: line.variantId,
            quantity: line.qty,
            properties: { _roro_pack: token, _roro_pack_kind: 'gift' }
          };
        });

        refs.cta.disabled = true;
        refs.cta.classList.add('is-loading');
        hideFeedback();

        // Se piden las secciones del carrito igual que hace `product-form.js`,
        // para que el cajón del theme pueda re-renderizarse.
        var sectionIds = Array.prototype.map
          .call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
            return el.dataset.sectionId;
          })
          .filter(Boolean);

        var body = { items: items };
        if (sectionIds.length) body.sections = sectionIds.join(',');

        // `RoroCart.post` resuelve SIEMPRE, también con la red caída o con un
        // 429 de Shopify que devuelve HTML: el cuerpo se lee como texto y solo
        // se parsea si es JSON. Así el cliente nunca ve el mensaje interno del
        // motor de JS — ver `assets/roro-cart-fetch.js`.
        // Sin `throw`/`catch` a propósito: el fallo se decide mirando
        // `result.ok`, no cazando excepciones. Así es IMPOSIBLE que un
        // `error.message` del motor de JS acabe en pantalla, que es justo lo
        // que pasaba (el «The string did not match the expected pattern» de
        // WebKit al parsear una respuesta que no era JSON).
        window.RoroCart.post(ROUTES.add, body)
          .then(function (result) {
            if (!result.ok) {
              showFeedback(window.RoroCart.message(result.data, null, STRINGS.error), true);
              return;
            }

            var sections = result.data.sections;

            // Aquí se sigue pidiendo `/cart.js` entero y no se usa
            // `RoroCart.cartAfterAdd`: `applyPackCode` necesita los códigos
            // pegados al carrito, y esos no viajan en el HTML del cajón.
            return getCart()
              .then(function (before) {
                return applyPackCode(before).then(function (cart) {
                  // `applyPackCode` devuelve el MISMO objeto cuando no pide
                  // nada, y entonces el HTML del `add` vale tal cual.
                  if (cart === before) return { cart: cart, sections: sections };

                  // Si acaba de pedir el código, ese HTML es de ANTES del
                  // descuento: el cajón se abría sin el −5% aunque el carrito
                  // ya lo tuviera, y `roro-cart-bundle-discount.js` no repinta
                  // porque ve el código puesto. Se pide el cajón otra vez y se
                  // abre una sola vez, ya rebajado.
                  return freshSections(sections).then(function (fresh) {
                    return { cart: cart, sections: fresh };
                  });
                });
              })
              .then(function (state) {
                var cart = state.cart;
                lines = [];
                save();
                closePanel();
                render();
                notifyCart(cart, state.sections);

                var done = refs.cta.dataset.gpbLabelDone;
                if (done) {
                  refs.cta.textContent = done;
                  setTimeout(function () {
                    refs.cta.textContent = refs.cta.dataset.gpbLabelIdle || done;
                  }, 2500);
                }
              });
          })
          .catch(function () {
            // Red de seguridad para un fallo inesperado del navegador: mensaje
            // de la tienda, nunca el del motor de JS.
            showFeedback(STRINGS.error || '', true);
          })
          .then(function () {
            refs.cta.classList.remove('is-loading');
            render();
          });
      });
    }

    /* ---- Pestañas de tramo ----------------------------------------------
       Sin fetch: las tres rejillas ya están en el DOM, así que el cambio es
       instantáneo y sin JS los tres tramos quedan visibles y comprables. */

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-gpb-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-gpb-panel]'));

    function selectBand(id) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.gpbTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.gpbPanel !== id;
      });
      // La banda que acaba de aparecer puede tener el faro ya en pantalla.
      if (typeof onBandShown === 'function') onBandShown();
    }

    /* `?band=<handle de coleccion>` es el idioma que hablan los enlaces de fuera:
       el mega menu y el drawer mandan aqui con el tramo ya elegido en vez de a un
       listado de coleccion (ver `snippets/roro-mega-cards.liquid`). Se usa el handle
       y no el id de bloque porque el handle existe fuera del tema y se puede escribir
       en un enlace; el id de bloque, no. */

    function tabIdForHandle(handle) {
      if (!handle) return null;
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].dataset.gpbBandHandle === handle) return tabs[i].dataset.gpbTab;
      }
      return null;
    }

    // Deja el tramo abierto en la barra de direcciones: recargar o compartir el
    // enlace devuelve la misma pestana. `replaceState` y no `pushState` porque
    // cambiar de tramo no es navegar: el boton Atras tiene que salir de la pagina.
    function syncUrlToBand(id) {
      if (!window.history || !window.history.replaceState) return;
      var tab = tabs.filter(function (candidate) {
        return candidate.dataset.gpbTab === id;
      })[0];
      var handle = tab && tab.dataset.gpbBandHandle;
      if (!handle) return;
      var url = new URL(window.location.href);
      url.searchParams.set('band', handle);
      window.history.replaceState(window.history.state, '', url.toString());
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        selectBand(tab.dataset.gpbTab);
        syncUrlToBand(tab.dataset.gpbTab);
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (next === null) return;
        event.preventDefault();
        selectBand(tabs[next].dataset.gpbTab);
        syncUrlToBand(tabs[next].dataset.gpbTab);
        tabs[next].focus();
      });
    });

    // Tramo de arranque. Sin parametro, o con un handle que no es de ninguna banda,
    // manda el primero, que es el que ya viene abierto desde Liquid.
    var params = new URLSearchParams(window.location.search);
    var initialBand = tabIdForHandle(params.get('band'));
    if (initialBand) selectBand(initialBand);

    /* ---- Scroll infinito por banda ---------------------------------------
       Un `for` de Liquid sobre `collection.products` corta en 50 y la banda
       «до 1 900» tiene 58, asi que la seccion NO puede pintar la coleccion
       entera aunque quiera. Lo que falta llega por
       `templates/collection.pack-cards.liquid`, que devuelve una pagina de
       tarjetas sin layout.

       Se pide al acercarse el faro (400px antes de verlo), no con un boton:
       el 93,4% del trafico es movil y ahi «cargar mas» es un toque de mas por
       cada 12 piezas. */

    // Lo rellena `setupInfiniteScroll`. `selectBand` lo llama para que la banda
    // recien mostrada compruebe su faro sin esperar a un scroll.
    var onBandShown = null;

    var PAGE_SIZE = parseInt(root.dataset.gpbPageSize, 10) || 12;
    var PER_BAND = parseInt(root.dataset.gpbPerBand, 10) || PAGE_SIZE;
    var productsScript = root.querySelector('[data-na-products]');
    var SHEET_ID = 'NaSheet-' + SECTION_ID;

    /**
     * Mete los productos de una pagina nueva en los indices que ya existen y
     * reescribe el <script> que lee el bottom sheet, para que una pieza traida
     * por scroll se pueda elegir igual que las primeras.
     */
    function mergeProducts(list) {
      if (!Array.isArray(list) || !list.length) return;

      var added = false;
      list.forEach(function (p) {
        if (!p || BY_ID[String(p.id)]) return;
        BY_ID[String(p.id)] = p;
        PRODUCTS.push(p);
        (p.variants || []).forEach(function (v) {
          VARIANT_OWNER[String(v.id)] = p;
        });
        added = true;
      });

      if (!added || !productsScript) return;

      productsScript.textContent = JSON.stringify(PRODUCTS);
      // Repinta swatches e indicadores de las tarjetas nuevas y relee el JSON.
      if (window.RoroProductCarousel && window.RoroProductCarousel.refresh) {
        window.RoroProductCarousel.refresh(root);
      }
      // Los corazones de wishlist van por delegacion, pero su estado inicial
      // (lleno o vacio) se sincroniza con este evento.
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: {} }));
    }

    function setupInfiniteScroll() {
      // Los faros que hay que vigilar a mano cuando el observer no dispara.
      var watchers = [];

      // Cuánto antes del final se pide la tanda siguiente. Con 400px llegaba con
      // el pie ya en pantalla y lo empujaba: CLS de 0,06 (móvil) a 0,11
      // (escritorio) en /pages/nabir, medido el 2026-09-25. Mismo arreglo que el
      // scroll infinito de `assets/roro-product-listing.js`.
      var PREFETCH_MARGIN = 1000;

      panels.forEach(function (panel) {
        var sentinel = panel.querySelector('[data-gpb-more]');
        var grid = panel.querySelector('.rgp__grid');
        var bandUrl = panel.dataset.gpbBandUrl;
        if (!sentinel || !grid || !bandUrl) return;

        // La primera tanda ya esta en el HTML: se sigue por donde lo dejo.
        var state = {
          next: Math.floor(PER_BAND / PAGE_SIZE) + 1,
          busy: false,
          done: false
        };

        function load() {
          if (state.busy || state.done) return;
          state.busy = true;

          var url = bandUrl + '?view=pack-cards&page=' + state.next;

          fetch(url, { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) throw new Error('page ' + state.next);
              return response.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');

              mergeProducts(readJSON(doc.querySelector('[data-pack-page-products]')) || []);

              // Una pieza puede repetirse si alguien desalinea el tamano de
              // pagina de la plantilla y `products_per_band`. Mejor saltarla
              // que pintarla dos veces. Se compara con un Set en vez de meter
              // el id en un selector: no hace falta escapar nada.
              var present = new Set();
              grid.querySelectorAll('[data-gpb-cell]').forEach(function (cell) {
                present.add(cell.dataset.gpbCell);
              });

              var fragment = document.createDocumentFragment();
              doc.querySelectorAll('[data-gpb-cell]').forEach(function (cell) {
                if (present.has(cell.dataset.gpbCell)) return;
                present.add(cell.dataset.gpbCell);

                // La plantilla no sabe el id de esta seccion, asi que el sheet
                // que anuncian sus botones se corrige aqui.
                cell.querySelectorAll('[aria-controls]').forEach(function (el) {
                  el.setAttribute('aria-controls', SHEET_ID);
                });

                fragment.appendChild(document.importNode(cell, true));
              });

              grid.appendChild(fragment);

              if (doc.querySelector('[data-pack-next]')) {
                state.next += 1;
              } else {
                state.done = true;
                sentinel.hidden = true;
              }

              renderBadges();
            })
            .catch(function () {
              // Una pagina que falla no debe dejar el faro girando para siempre.
              state.done = true;
              sentinel.hidden = true;
            })
            .then(function () {
              state.busy = false;
            });
        }

        /* Dos disparadores para lo mismo, y no por gusto.
           `IntersectionObserver` es el bueno, pero NO se ejecuta cuando el
           documento no esta pintando — misma trampa que ya documenta
           `assets/roro-product-carousel.js` con `requestAnimationFrame`. El
           `scroll` pasivo es la red: si el observer se ha quedado dormido, el
           primer gesto del cliente trae la pagina siguiente igual. `load()` ya
           es idempotente (`state.busy`), asi que llamarlo dos veces no pide dos
           veces la misma pagina. */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) load();
              });
            },
            { rootMargin: PREFETCH_MARGIN + 'px 0px' }
          ).observe(sentinel);
        }

        watchers.push(function () {
          if (panel.hidden || state.done || state.busy) return;
          var box = sentinel.getBoundingClientRect();
          if (box.top < window.innerHeight + PREFETCH_MARGIN && box.bottom > -PREFETCH_MARGIN) load();
        });
      });

      if (!watchers.length) return;

      var ticking = false;
      function checkAll() {
        if (ticking) return;
        ticking = true;
        window.setTimeout(function () {
          ticking = false;
          watchers.forEach(function (fn) {
            fn();
          });
        }, 150);
      }

      onBandShown = checkAll;
      window.addEventListener('scroll', checkAll, { passive: true });
      window.addEventListener('resize', checkAll, { passive: true });
      // Una banda corta puede caber entera en la primera pantalla: sin esta
      // llamada su segunda pagina no se pediria hasta que alguien scrollease.
      checkAll();
    }

    /* ---- Arranque -------------------------------------------------------- */

    setupInfiniteScroll();
    restore();
    syncPanel();
    render();
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-gpb-root]'), initRoot);
    if (context !== document && context.matches && context.matches('[data-gpb-root]')) {
      initRoot(context);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // El theme editor reinyecta la sección entera al tocar cualquier setting.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
